import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.css';
import App from './app';
import FirebaseProvider from './api';

ReactDOM.render(
  <React.StrictMode>
    <FirebaseProvider>
      <App />
    </FirebaseProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);
